import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { AuthShell } from "../components/AuthShell";

export default function Login() {
  const { signIn, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/traces", { replace: true });
    return null;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn(email, password);
      navigate("/traces", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Error desconocido");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell tag="Operadores · organización">
      <h1 className="login-title">Bienvenido de vuelta</h1>
      <p className="login-subtitle">
        Iniciá sesión para ver los traces y los incidentes de tu organización.
      </p>

      <form onSubmit={onSubmit} className="login-form">
        <div>
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            placeholder="vos@tu-organizacion.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
          />
        </div>

        <div>
          <label className="label">Contraseña</label>
          <input
            className="input"
            type="password"
            placeholder="Tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        {error && (
          <div className="login-error" role="alert" aria-live="assertive">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="btn btn-primary"
          style={{ justifyContent: "center", width: "100%", height: 44 }}
        >
          {loading ? "Entrando…" : "Entrar"}
        </button>

        <div className="login-register-row">
          ¿No tenés cuenta? Pedile el alta a un administrador.
        </div>
      </form>
    </AuthShell>
  );
}
